/*
  Wubs priskonfigurator – räknar priset ur produktens custom.prisregler.

  ⚠️ Den här evaluatorn är en SPEGLING av raknaPris() i shopify-app/shared/pris.js och
  rakna() i prodrev/pris_kompilera.py. Alla tre måste räkna likadant: Python-sidan är
  bevisad mot Apippas riktiga formler över 73 593 kombinationer, JS-funktionen mot ett
  facit ur Python. Ändras reglerna här måste de tre följas åt.

  Priset som visas är alltså samma tal som cart-transformen sätter serversidan. Klienten
  skickar bara kundens VAL (_pris_val) – aldrig ett belopp.
*/
(function () {
  /* 🧨 ENGÅNGSSPÄRR. Snippeten laddar sitt eget <script>, och en v2-produkt renderar snippeten
     en gång per modell – alltså två identiska script-taggar, två körningar, och varje lyssnare
     bunden två gånger. Uppmätt: ett klick på "Lägg i varukorg" skickade TVÅ cart/add.
     Spärren sitter här och inte i Liquid, så den håller oavsett hur många gånger taggen hamnar
     på sidan (quick add, sektionshämtning, framtida anropare). */
  if (window.__wubsPkInit) return;
  window.__wubsPkInit = true;

  /* ⚠️ FLERA ROTTER SEDAN 2026-10-01. `sattsteg` bär TVÅ prismodeller – furu 21 mm och MDF 19 mm
     har olika formler – och Liquid renderar därför en konfigurator per modell, alla dolda utom
     den som hör till vald variant. Förut plockades bara den FÖRSTA roten med querySelector, så
     den andra hade varit död markup. Varje rot får nu sin egen instans; de delar ingenting. */
  var rotter = [].slice.call(document.querySelectorAll('[data-wubs-pk]'));
  if (!rotter.length) return;
  rotter.forEach(init);

  function init(root) {

    var reglerEl = root.querySelector('[data-pk-regler]');
    var regler;
    try { regler = JSON.parse(reglerEl.textContent); } catch (e) { return; }

    /* ═══════════════════════════════════════════════════════════════════════════════
       VARIANTEN MÅSTE FÖLJA KUNDENS VAL (2026-10-06, order #6595)
       ═══════════════════════════════════════════════════════════════════════════════
       Förut skickades `data-variant` = produktsidans FÖRVALDA variant, oavsett vad kunden
       valde i konfiguratorn. Priset kom ur `_components` och blev rätt, men varianttiteln
       följde med ut på följesedeln och i kundens orderbekräftelse: #6595 beställde
       "Rak (Typ 2) + Färdigmålad 0502-y" och papperet sa "Med spår + Obehandlad".
       Verkstaden hade tillverkat fel vara, och ingenting hade sagt ifrån.

       Rätt variant finns – produkterna har en variant per kombination. Vi filtrerar dem på
       de axlar modellen faktiskt styr och kräver att EXAKT EN blir kvar.

       🔴 BLIR DET INTE EXAKT EN BLOCKERAS KÖPET. Det gamla felet var farligt just för att det
          misslyckades tyst; en fallback till någon variant hade bevarat den egenskapen.
          Hellre en order som inte går att lägga än en som tillverkas fel.
       ⚠️ Etiketterna matchar inte ordagrant: "Rak (Typ 2)" mot variantens "Rak",
          "Färdigmålad 0502-y" mot "Färdigmålad (NCS 0502-Y)", "16mm MDF" mot "16 mm MDF".
          Därför jämförs ORDMÄNGDER, och siffror/bokstäver delas isär ("16mm" → "16","mm").
          En match kräver att den ena mängden rymmer den andra OCH att den är unik på axeln.
       ⚠️ En modellinput utan motsvarande variantaxel (fönsterbänkens `avrundningar`) styr
          ingen variant och hoppas över. En variantaxel utan modellinput (sättstegets `Kulör`)
          lämnas ofiltrerad – går det ändå att få fram exakt en variant är valet entydigt. */
    var variantLista = [];
    var optionNamn = [];
    try {
      variantLista = JSON.parse(root.querySelector('[data-pk-varianter]').textContent) || [];
      optionNamn = JSON.parse(root.querySelector('[data-pk-optionnamn]').textContent) || [];
    } catch (e) { variantLista = []; }

    function ordmangd(str) {
      return String(str == null ? '' : str)
        .toLowerCase()
        .replace(/[åä]/g, 'a').replace(/ö/g, 'o')
        .replace(/(\d)([a-zåäö])/gi, '$1 $2').replace(/([a-zåäö])(\d)/gi, '$1 $2')
        .split(/[^a-z0-9]+/).filter(Boolean);
    }
    function rymmer(a, b) { return b.every(function (t) { return a.indexOf(t) >= 0; }); }
    function passar(altEtikett, optVarde) {
      var A = ordmangd(altEtikett), B = ordmangd(optVarde);
      if (!A.length || !B.length) return false;
      return rymmer(A, B) || rymmer(B, A);
    }

    /* Vilken variantaxel styr varje val-input?
       🧨 KRAVET ÄR BIJEKTION, och det är inte formalism. Första försöket krävde bara att varje
          ALTERNATIV träffade ett värde. Då kopplades fönsterbänkens input `farg`
          (NCS 0502-y / 0500-n / Egen) till axeln "Ytbehandling" – som har FEM värden och i
          själva verket beskrivs av TVÅ inputs (`ytbehandling` + `farg`). En obehandlad bänk
          hade då fått varianten "Färdigmålad (NCS 0502-Y)": exakt det fel vi rättar, fast nytt.
          Att "alla kombinationer löste sig" dolde det – de löste sig till FEL variant.
       Därför krävs nu: varje alternativ träffar exakt ett värde, varje värde träffas av exakt
       ett alternativ, och antalet är lika. En axel får dessutom bara ägas av EN input. */
    /* STEG 0 – EXAKT KOPPLING SLÅR ALLT. Bär varianterna `custom.matt_modell` och snippeten
       renderas för en namngiven undermodell (`data-pk-modell`), är urvalet redan avgjort:
       sättstegets Furu 21 mm bär `furu21`, MDF 19 mm bär `mdf19`. Ingen etikettmatchning behövs,
       och ingen kan gissa fel. Saknas fältet fortsätter vi till axelmatchningen nedan. */
    var modellNyckel = root.getAttribute('data-pk-modell') || '';
    if (modellNyckel) {
      var trafffade = variantLista.filter(function (v) { return v.mm && String(v.mm) === modellNyckel; });
      if (trafffade.length) variantLista = trafffade;
    }

    var axelForInput = {};
    var vardeForAlt = {};   // nyckel → { slug → variantvärde } – kopplingen som bijektionen bevisade
    var parForAxel = [];
    var taganaAxlar = {};
    /* 🔴 OMDÖPTA VARIANTVÄRDEN (2026-10-30, smyg #6671/#6695). Typ-värdet döptes om "Rak" → "Rak bakkant"
       i admin. "Rak (Typ 2)" och "Rak bakkant" rymmer inte varandra, så kartan föll och ALLA 16 kombinationer
       fick produktsidans förval – mejl och plocklista sa "Grundmålad" när kunden köpt "Färdigmålad 0500".
       Därför en andra, mildare matchning: ordmängderna DELAR minst ett ord. Den används bara när den
       strikta inte ger bijektion, och samma bijektionskrav gäller – ett ord som "typ" eller "mm" som
       delas med flera värden ger ingen entydig koppling och alltså ingen karta (förvalet, som förut). */
    function delarOrd(a, u) {
      var A = ordmangd(a), B = ordmangd(u);
      return A.some(function (t) { return B.indexOf(t) >= 0; });
    }
    var matchningar = [passar, function (a, u) { return passar(a, u) || delarOrd(a, u); }];
    (regler.inputs || []).forEach(function (inm) {
      if (inm.typ !== 'val' || !(inm.alternativ || []).length) return;
      for (var mi = 0; mi < matchningar.length; mi++) {
        var m = matchningar[mi];
        for (var ai = 0; ai < optionNamn.length; ai++) {
          if (taganaAxlar[ai]) continue;
          var varden = {};
          variantLista.forEach(function (v) { varden[v.opt[ai]] = 1; });
          var unika = Object.keys(varden);
          if (unika.length !== inm.alternativ.length) continue;
          var karta = {};
          var altOk = inm.alternativ.every(function (alt) {
            var t = unika.filter(function (u) { return m(alt.etikett, u); });
            if (t.length === 1) karta[alt.slug] = t[0];
            return t.length === 1;
          });
          var vardeOk = unika.every(function (u) {
            return inm.alternativ.filter(function (alt) { return m(alt.etikett, u); }).length === 1;
          });
          if (altOk && vardeOk) {
            axelForInput[inm.nyckel] = ai; vardeForAlt[inm.nyckel] = karta; taganaAxlar[ai] = 1; return;
          }
        }
      }
    });

    /* KONSTANT: en input med ETT alternativ är inget val utan en uppgift om varan. Den får filtrera
       utan bijektion, men bara om alternativet träffar exakt ett värde på exakt en ledig axel. */
    (regler.inputs || []).forEach(function (inm) {
      if (inm.typ !== 'val' || (inm.alternativ || []).length !== 1 || axelForInput[inm.nyckel] != null) return;
      var et = inm.alternativ[0].etikett, traff = [];
      for (var ai = 0; ai < optionNamn.length; ai++) {
        if (taganaAxlar[ai]) continue;
        var u = {}; variantLista.forEach(function (v) { u[v.opt[ai]] = 1; });
        if (Object.keys(u).filter(function (x) { return passar(et, x); }).length === 1) traff.push(ai);
      }
      if (traff.length === 1) {
        axelForInput[inm.nyckel] = traff[0]; taganaAxlar[traff[0]] = 1;
        var uu0 = {}; variantLista.forEach(function (v) { if (passar(et, v.opt[traff[0]])) uu0[v.opt[traff[0]]] = 1; });
        vardeForAlt[inm.nyckel] = {}; vardeForAlt[inm.nyckel][inm.alternativ[0].slug] = Object.keys(uu0)[0];
      }
    });

    /* "INGEN FÄRG" (Liam 2026-10-30, order #6594). Fönsterbänkens Färg gäller bara Färdigmålad, men
       rutan syntes och kostade även vid Obehandlad/Grundmålad: #6594 (två obehandlade furubänkar)
       betalade ~100 kr för NCS 0502-y och papperet skrev "Ytbehandling: Obehandlad · Färg: NCS 0502-y".
       Modellen har därför ett alternativ "Ingen färg = 0" (slug `ingen_…`) – det är kundens val när
       färgen inte gäller, så att servern (cart transform, prisvakten) räknar samma 0 kr utan en rad
       ny kod. Det alternativet är INTE ett riktigt val: det deltar inte i variantkartan och visas
       aldrig. Vilka val som bär färgen avgörs av VARIANTERNA nedan (se `beroenden`), inte av namn. */
    function arIngen(a) { return !!a && /^ingen(_|$)/.test(a.slug || ''); }
    function riktiga(inm) { return (inm.alternativ || []).filter(function (a) { return !arIngen(a); }); }

    /* PAR: en variantaxel kan beskrivas av TVÅ inputs. Fönsterbänkens axel "Ytbehandling" har fem
       värden som är `ytbehandling` (3) × `farg` (3) hopslaget – Obehandlad och Grundmålad struntar
       i färgen, Färdigmålad bär den. Villkoret är därför INTE bijektion (9 ≠ 5) utan att varje
       KOMBINATION av paret träffar exakt ett värde, och att alla värden går att nå. Då är varje
       val entydigt, vilket är det enda som betyder något. */
    var lediga = (regler.inputs || []).filter(function (i) {
      return i.typ === 'val' && (i.alternativ || []).length > 1 && axelForInput[i.nyckel] == null;
    });
    for (var ai2 = 0; ai2 < optionNamn.length; ai2++) {
      if (taganaAxlar[ai2]) continue;
      var uu = {}; variantLista.forEach(function (v) { uu[v.opt[ai2]] = 1; });
      var varden = Object.keys(uu);
      var hittat = false;
      for (var x = 0; x < lediga.length && !hittat; x++) {
        for (var y = x + 1; y < lediga.length && !hittat; y++) {
          var A = lediga[x], B = lediga[y], natt = {}, allaEntydiga = true;
          riktiga(A).forEach(function (a) {
            riktiga(B).forEach(function (b) {
              var tr = varden.filter(function (vv) { return passar(a.etikett + ' ' + b.etikett, vv); });
              if (tr.length !== 1) allaEntydiga = false; else natt[tr[0]] = 1;
            });
          });
          if (allaEntydiga && Object.keys(natt).length === varden.length) {
            parForAxel.push({ a: A.nyckel, b: B.nyckel, ai: ai2 });
            taganaAxlar[ai2] = 1; hittat = true;
          }
        }
      }
    }

    /* 🔴 FIXEN SLÅR PÅ BARA NÄR KOPPLINGEN ÄR FULLSTÄNDIG. Går NÅGON kombination inte att lösa
       till exakt en variant är kartan ofullständig, och då är varje gissning farligare än dagens
       kända fel. Då används produktsidans variant precis som förut – ingen ny risk införs – och
       `kartaKomplett` är falsk så ingen tror att produkten är åtgärdad.
       Uppmätt 2026-10-06: smyg 16/16 löser sig. Fönsterbänken (en variantaxel delad på två
       inputs) och sättsteget (materialaxeln har sex värden, varje undermodell ett enda
       alternativ) löser INGEN kombination och går alltså fortfarande på förvalet.
       De två behöver en LAGRAD koppling alternativ→variant, inte etikettmatchning. */
    var kartaKomplett = false;
    if (variantLista.length === 1) { kartaKomplett = true; }
    else if (variantLista.length && (Object.keys(axelForInput).length || parForAxel.length)) {
      var valInputs = (regler.inputs || []).filter(function (i) { return i.typ === 'val' && (i.alternativ || []).length; });
      var komb = [{}];
      valInputs.forEach(function (i) {
        var nya = [];
        komb.forEach(function (c) {
          riktiga(i).forEach(function (a) { var k = {}; Object.keys(c).forEach(function (x) { k[x] = c[x]; }); k[i.nyckel] = a.slug; nya.push(k); });
        });
        komb = nya;
      });
      kartaKomplett = komb.length > 0 && komb.every(function (c) { return valjViaKarta(c) != null; });
    }

    /* BEROENDEN – när ska "Ingen färg" gälla? För varje par (styrande input, input med ett
       ingen-alternativ): ett styrande val där ALLA riktiga färger landar på samma variantvärde
       ("Obehandlad", "Grundmålad") struntar i färgen. Där sätts färgen till "Ingen" och rutan döljs.
       Ett val där färgerna ger olika varianter ("Färdigmålad (NCS 0502-Y)" / "(NCS 0500-N)" …) bär
       färgen: rutan visas och "Ingen" går inte att välja.
       ⚠️ Kravet är också att styrvalet + "Ingen" landar på EXAKT det värdet – annars hade valet
          ingen variant, och köpet låses hellre än att det gissas. */
    var beroenden = [];
    var ingenUtanStyrning = [];
    function inputMedNyckel(n) { return (regler.inputs || []).filter(function (i) { return i.nyckel === n; })[0]; }
    function traffadeVarden(etikett, ai) {
      var ut = {};
      variantLista.forEach(function (v) { if (passar(etikett, v.opt[ai])) ut[v.opt[ai]] = 1; });
      return Object.keys(ut);
    }
    if (kartaKomplett) parForAxel.forEach(function (par) {
      var iA = inputMedNyckel(par.a), iB = inputMedNyckel(par.b);
      [[iA, iB], [iB, iA]].forEach(function (pr) {
        var styr = pr[0], dep = pr[1];
        var ingen = (dep.alternativ || []).filter(arIngen)[0];
        if (!ingen) return;
        var irrelevant = {};
        riktiga(styr).forEach(function (s) {
          var traffar = {};
          riktiga(dep).forEach(function (d) {
            traffadeVarden(s.etikett + ' ' + d.etikett, par.ai).forEach(function (x) { traffar[x] = 1; });
          });
          var t = Object.keys(traffar);
          if (t.length !== 1) return;
          var medIngen = traffadeVarden(s.etikett + ' ' + ingen.etikett, par.ai);
          if (medIngen.length === 1 && medIngen[0] === t[0]) irrelevant[s.slug] = 1;
        });
        if (Object.keys(irrelevant).length) beroenden.push({ styr: styr, dep: dep, ingen: ingen, irrelevant: irrelevant });
      });
    });
    /* Ett ingen-alternativ som ingen styrning hittades för får ALDRIG väljas – då vore det en
       gratis färg på en målad bänk. Rutan beter sig då exakt som före 2026-10-30. */
    (regler.inputs || []).forEach(function (inm) {
      var ingen = (inm.alternativ || []).filter(arIngen)[0];
      if (ingen && !beroenden.some(function (b) { return b.dep === inm; })) ingenUtanStyrning.push({ dep: inm, ingen: ingen });
    });

    function valjViaKarta(val) {
      var kvar = variantLista.slice();
      parForAxel.forEach(function (par) {
        var iA = (regler.inputs || []).filter(function (i) { return i.nyckel === par.a; })[0];
        var iB = (regler.inputs || []).filter(function (i) { return i.nyckel === par.b; })[0];
        var aA = (iA.alternativ || []).filter(function (a) { return a.slug === val[par.a]; })[0];
        var aB = (iB.alternativ || []).filter(function (a) { return a.slug === val[par.b]; })[0];
        if (!aA || !aB) return;
        kvar = kvar.filter(function (v) { return passar(aA.etikett + ' ' + aB.etikett, v.opt[par.ai]); });
      });
      Object.keys(axelForInput).forEach(function (nyckel) {
        var ai = axelForInput[nyckel];
        var inm = (regler.inputs || []).filter(function (i) { return i.nyckel === nyckel; })[0];
        var alt = (inm.alternativ || []).filter(function (a) { return a.slug === val[nyckel]; })[0];
        if (!alt) return;
        var mal = (vardeForAlt[nyckel] || {})[alt.slug];
        kvar = kvar.filter(function (v) { return v.opt[ai] === mal; });
      });
      return kvar.length === 1 ? kvar[0].id : null;
    }

    function valjVariant(val) {
      if (!kartaKomplett) return parseInt(root.getAttribute('data-variant'), 10) || null;
      return valjViaKarta(val);
    }
    if (!regler || !regler.inputs) return;

    var falt = {};
    [].slice.call(root.querySelectorAll('[data-pk-input]')).forEach(function (el) {
      falt[el.getAttribute('data-pk-input')] = el;
    });

    var priceEl = root.querySelector('[data-pk-price]');
    var ordEl = root.querySelector('[data-pk-ord]');
    // Kampanjprocenten från Liquid (snippets/wubs-kampanj.liquid). BARA visningen – se laggIVarukorg:
    // _components bär fortsatt ordinarie pris, rabatten dras av Shopify i kassan.
    var kampanjPct = Number(root.getAttribute('data-kampanj-pct')) || 0;
    if (!(kampanjPct > 0 && kampanjPct < 100)) kampanjPct = 0;
    var perUnitEl = root.querySelector('[data-pk-perunit]');
    /* FRÅN-PRIS (2026-10-29) – räknat i Liquid (snippets/wubs-fran-pris-regler.liquid) med samma
       formel som rakna() nedan, och samma tal som JSON-LD. Visas bara medan priset inte går att
       räkna (mått saknas/under min). Saknas attributen är allt som förut ("0 kr"). */
    var franOre = Number(root.getAttribute('data-fran-ore')) || 0;
    var franOrdOre = Number(root.getAttribute('data-fran-ord-ore')) || 0;
    var franText = root.getAttribute('data-fran-text') || '';
    var noteEl = root.querySelector('[data-pk-note]');
    var qtyInput = root.querySelector('[data-pk-qty]');
    var atc = root.querySelector('[data-pk-atc]');

    /* EGEN NCS (Liam 2026-10-01). Några modeller har ett alternativ som heter "Egen NCS" –
       då måste kunden få ange koden, annars vet verkstaden inte vilken kulör det är.
       Fältet ligger alltid i markupen och visas bara när ett sådant alternativ är valt.

       ⚠️ Villkoret kräver BÅDE "egen" och "ncs". `fonsterbank` har också alternativet
          "Grund + topp (NCS S 0502-Y)" – det är en BESTÄMD kulör, och ett enkelt /ncs/i
          (som ledstången använder, där alla NCS-val är egna) hade öppnat fältet där och
          bett kunden ange en kod som redan är vald.
       Koden påverkar inte priset – den följer med som radegenskap till verkstaden. */
    var NCS_EGEN = /egen\s*ncs/i;
    var ncsWrap = root.querySelector('[data-pk-ncs-wrap]');
    var ncsInput = root.querySelector('[data-pk-ncs]');
    var ncsNote = root.querySelector('[data-pk-ncs-note]');
    var ncsProv = root.querySelector('[data-pk-ncs-prov]');

    /** Är ett alternativ som heter "Egen NCS" valt just nu? */
    function ncsVald(val) {
      return regler.inputs.some(function (inm) {
        if (inm.typ !== 'val') return false;
        var traff = null;
        inm.alternativ.forEach(function (a) { if (a.slug === val[inm.nyckel]) traff = a; });
        return !!traff && NCS_EGEN.test(traff.etikett || '');
      });
    }
    function ncsKod() { return ncsInput ? ncsInput.value.trim() : ''; }

    /** Visar fältet, swatchen och beskedet. Returnerar true när koden krävs men saknas. */
    function ncsRender(val) {
      var pa = !!ncsWrap && ncsVald(val);
      if (ncsWrap) ncsWrap.hidden = !pa;
      if (!pa) return false;
      var kod = ncsKod();
      // Skärmfärgen är en uppskattning – se varningarna i wubs-ncs.js. Null = koden går inte att tolka.
      var hex = kod && window.WubsNCS ? window.WubsNCS.hex(kod) : null;
      if (ncsProv) {
        ncsProv.hidden = !hex;
        if (hex) ncsProv.style.background = hex;
      }
      if (ncsNote) {
        ncsNote.textContent = !kod
          ? 'Fyll i koden för att kunna lägga i varukorgen.'
          : hex
            ? 'Ungefärlig återgivning – vi målar exakt efter koden.'
            : 'Kontrollera koden, t.ex. S 0502-Y eller S 1050-Y90R.';
        ncsNote.classList.toggle('is-fel', !!kod && !hex);
      }
      // En kod som inte går att tolka stoppar INTE köpet, bara en tom gör det – samma
      // gräns som ledstången drar. Formeln är publik och ungefärlig, och ska inte få
      // avgöra om en kund får beställa.
      return !kod;
    }

    function kr(n) { return Math.round(n).toLocaleString('sv-SE') + ' kr'; }

    /** Kundens val, i den form som skickas till servern. */
    function lasVal() {
      var val = {};
      regler.inputs.forEach(function (inm) {
        var el = falt[inm.nyckel];
        if (!el) return;
        val[inm.nyckel] = inm.typ === 'val' ? el.value : el.value.trim();
      });
      return val;
    }

    /** Speglar raknaPris() i shopify-app/shared/pris.js och rakna() i pris_kompilera.py.
        Kastar när konfigurationen inte går att prissätta. */
    function rakna(val) {
      var varden = {};
      var spec = {};
      regler.inputs.forEach(function (inm) {
        var ratt = val[inm.nyckel];
        if (inm.typ === 'val') {
          var traff = null;
          inm.alternativ.forEach(function (a) { if (a.slug === ratt) traff = a; });
          if (!traff) throw new Error('ogiltigt val');
          varden[inm.nyckel] = traff.varde;
          // "Ingen färg" skrivs inte ut – ingen rad "Färg" alls i korgen, i ordern eller på papperet.
          if (inm.alternativ.length > 1 && !arIngen(traff)) spec[inm.etikett] = traff.etikett;
          return;
        }
        if (ratt === '' || ratt == null) throw new Error('saknat mått');
        var v = Number(String(ratt).replace(',', '.'));
        if (!isFinite(v) || v <= 0) throw new Error('ogiltigt mått');
        if (inm.min != null) v = Math.max(v, inm.min);
        if (inm.max != null) v = Math.min(v, inm.max);
        varden[inm.nyckel] = v;
        spec[inm.etikett] = v + (inm.enhet ? ' ' + inm.enhet : '');
      });

      var summa = regler.bas;
      regler.termer.forEach(function (term) {
        var produkt = 1;
        term.forEach(function (f) { produkt *= (typeof f === 'number') ? f : varden[f]; });
        summa += produkt;
      });

      var engang = 0;
      if (regler.engang) {
        var v2 = regler.engang.villkor;
        if (!v2 || val[v2.nyckel] === v2.slug) {
          engang = regler.engang.belopp;
          spec[regler.engang.etikett] = engang.toLocaleString('sv-SE') + ' kr';
        }
      }
      // -1e-9 så att 4362,9999999 inte blir 4363 av misstag – samma som i Python och i verifieraren.
      // || 0 städar minus noll: Math.ceil(0 - 1e-9) är -0 och skrivs ut som "−0 kr".
      // `utan` = styckpriset utan engångskostnaden, för exemplaren efter det första.
      return { pris: Math.ceil(summa + engang - 1e-9) || 0, utan: Math.ceil(summa - 1e-9) || 0, engang: engang, spec: spec };
    }

    /** Klampar mot max direkt i fältet, så kunden ser gränsen i stället för att gissa. */
    var justerat = {};
    function klampa() {
      var notiser = [];
      regler.inputs.forEach(function (inm) {
        if (inm.typ === 'val') return;
        var el = falt[inm.nyckel];
        if (!el) return;
        if (el.value === '') { delete justerat[inm.nyckel]; return; }
        var v = Number(String(el.value).replace(',', '.'));
        if (!isFinite(v)) return;
        /* Beskedet ligger kvar tills fältet ändras, se wubs-matt-konfig.js (Tom 2026-11-02). */
        if (inm.max != null && v > inm.max) {
          justerat[inm.nyckel] = { fran: v, till: Number(inm.max) };
          el.value = inm.max;
          v = Number(inm.max);
        }
        var j = justerat[inm.nyckel];
        if (j && (v !== j.till || Number(inm.max) !== j.till)) { delete justerat[inm.nyckel]; j = null; }
        if (j) {
          var enh = inm.enhet ? ' ' + inm.enhet : '';
          notiser.push('Största ' + inm.etikett.toLowerCase() + ' här är ' + String(j.till).replace('.', ',') + enh +
            ', så vi räknar på det i stället för ' + String(j.fran).replace('.', ',') + enh);
        }
        if (inm.min != null && v > 0 && v < inm.min) {
          notiser.push('Min ' + inm.etikett.toLowerCase() + ' ' + inm.min + ' ' + (inm.enhet || ''));
        }
      });
      return notiser;
    }

    /** Sätter/döljer de beroende rutorna. Returnerar de select som fick nytt värde i koden. */
    function styrBeroenden() {
      var andrade = [];
      function satt(el, slug) { if (el.value !== slug) { el.value = slug; andrade.push(el); } }
      function visaIngen(el, slug, visa) {
        // Bara vid faktisk ändring: wubs-dd.js observerar attributen, och ett skrivet attribut är en mutation.
        [].forEach.call(el.options, function (o) {
          if (o.value !== slug) return;
          if (o.hidden !== !visa) o.hidden = !visa;
          if (o.disabled !== !visa) o.disabled = !visa;
        });
      }
      beroenden.forEach(function (b) {
        var elS = falt[b.styr.nyckel], elD = falt[b.dep.nyckel];
        if (!elS || !elD) return;
        var galler = !b.irrelevant[elS.value];
        var rad = elD.closest('.wubs-mk__field');
        if (rad && rad.hidden !== !galler) rad.hidden = !galler;
        visaIngen(elD, b.ingen.slug, !galler);
        if (!galler) satt(elD, b.ingen.slug);
        else if (elD.value === b.ingen.slug) satt(elD, riktiga(b.dep)[0].slug);
      });
      ingenUtanStyrning.forEach(function (u) {
        var el = falt[u.dep.nyckel];
        if (!el) return;
        visaIngen(el, u.ingen.slug, false);
        if (el.value === u.ingen.slug) satt(el, riktiga(u.dep)[0].slug);
      });
      return andrade;
    }

    function render() {
      /* Ett värde satt i koden syns inte i wubs-dd:s knapp förrän select:en skickar change.
         change kör render() en gång till – då finns inget kvar att ändra, så det tar slut där. */
      var andrade = styrBeroenden();
      if (andrade.length) {
        andrade.forEach(function (el) { el.dispatchEvent(new Event('change', { bubbles: true })); });
      }
      var notiser = klampa();
      var val = lasVal();
      var antal = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);

      var resultat = null;
      try { resultat = rakna(val); } catch (e) { resultat = null; }

      // Under minsta mått är konfigurationen giltig att räkna men inte att beställa.
      var underMin = notiser.some(function (n) { return n.indexOf('Min ') === 0; });
      var ncsSaknas = ncsRender(val);
      /* ⚠️ Priset och köpknappen har OLIKA villkor här. En vald "Egen NCS" utan kod är fullt
         prissatt – kulören kostar lika mycket vilken den är – så priset ska stå kvar. Uppmätt
         när de delade villkor: priset föll från 1 257 kr till 0 kr i samma ögonblick kunden
         valde egen kulör, som om valet hade slagit sönder uträkningen. */
      var prisOk = !!resultat && !underMin;
      var ok = prisOk && !ncsSaknas;

      if (atc) atc.disabled = !ok;
      if (priceEl && !prisOk && franOre) {
        priceEl.textContent = 'Från ' + kr(franOre / 100);
        if (ordEl) ordEl.textContent = franOrdOre ? kr(franOrdOre / 100) : '';
      } else if (priceEl) {
        /* Engångskostnaden EN gång, inte per styck: 3 fönsterbänkar med egen NCS bär 900 kr, inte 2 700. */
        var ordinarie = prisOk ? resultat.pris + (antal - 1) * resultat.utan : 0;
        // Samma uträkning som produktkortet: pris × (100 − procent) / 100, avrundat till krona i kr().
        priceEl.textContent = prisOk ? kr(kampanjPct ? ordinarie * (100 - kampanjPct) / 100 : ordinarie) : '0 kr';
        if (ordEl) ordEl.textContent = prisOk && kampanjPct ? kr(ordinarie) : '';
      }

      if (perUnitEl) {
        var taxa = null;
        regler.inputs.forEach(function (inm) {
          if (taxa == null && inm.typ !== 'val' && inm.pris != null) taxa = inm;
        });
        perUnitEl.textContent = taxa
          ? (taxa.enhet === 'cm'
              ? (taxa.pris * 100).toLocaleString('sv-SE', { maximumFractionDigits: 2 }) + ' kr/löpmeter'
              : taxa.pris.toLocaleString('sv-SE', { maximumFractionDigits: 2 }) + ' kr/' + (taxa.enhet || 'st'))
          : '';
      }

      if (noteEl) {
        var delar = notiser.slice();
        if (!resultat) delar.push(franOre && franText ? franText + ' · Ange mått för exakt pris' : 'Ange mått för pris');
        // Engångskostnaden är en verklig överraskning på 500–900 kr – visa den, inte bara i totalen.
        if (resultat && resultat.engang) {
          delar.push(regler.engang.etikett + ' ' + kr(resultat.engang) + ' tillkommer en gång');
        }
        if (resultat && antal > 1) delar.push('× ' + antal + ' st');
        noteEl.textContent = delar.join(' · ');
        noteEl.classList.toggle('is-justerat', Object.keys(justerat).length > 0);
      }

      /* Varianten avgörs av valen, inte av produktsidans förval. Går den inte att bestämma
         entydigt är `ok` falskt och köpknappen låses – se kommentaren vid valjVariant(). */
      var vid = valjVariant(val);
      if (vid == null) {
        ok = false;
        if (noteEl && noteEl.textContent.indexOf('kombination') < 0) {
          noteEl.textContent = (noteEl.textContent ? noteEl.textContent + ' · ' : '') +
            'Den här kombinationen går inte att beställa här – kontakta oss så hjälper vi dig.';
        }
      }
      return { ok: ok, val: val, antal: antal, resultat: resultat, vid: vid, ncs: ncsSaknas || !ncsWrap || ncsWrap.hidden ? '' : ncsKod() };
    }

    var skickar = false;   // dubbeltryck på mobilen la måttbeställningen i korgen två gånger
    function laggIVarukorg() {
      var s = render();
      if (!s.ok || skickar) return;
      /* 🔴 ALDRIG `data-variant` (produktsidans förval) – det var felet på #6595. */
      var vid = s.vid;
      if (!vid) return;

      // Priset skickas som ett komponentbelopp och Function Studios Expand-block sätter
      // radens pris till det. Varför inte variantpris × antal: en taxa på 64,125 kr/cm
      // ryms inte i ett variantpris (två decimaler), så den vägen gav några kronor fel.
      //
      // ⚠️ Beloppet är därmed klientstyrt. Det stängs i stället i andra änden: varje order
      //    räknas om serversidan ur _pris_val + custom.prisregler, och avviker den flaggas
      //    ordern. Manipulation upptäcks alltså, den förhindras inte.
      var props = { '_pris_val': JSON.stringify(s.val) };
      // Specen som synliga radegenskaper – Expand behåller dem (till skillnad från merge).
      Object.keys(s.resultat.spec).forEach(function (k) { props[k] = s.resultat.spec[k]; });
      // Egen NCS-kod, samma egenskapsnamn som ledstångskonfiguratorn sätter.
      if (s.ncs) props['NCS-kod'] = s.ncs;

      /* ⚠️⚠️ SPECEN MÅSTE MED NER I `_components`, annars finns den inte på papperet.
         Cart-transformens Expand gör raden till en BUNT: kundens radegenskaper hamnar på
         line item-GRUPPEN, och komponentraden – den enda `order.line_items` innehåller, och
         alltså den enda Order Printer kan loopa – blir tom. Uppmätt på order #6594
         (2026-10-05): två måttbeställda fönsterbänkar, 117,7×11 och 80×15 cm, och BÅDA
         pappren skrev "Fönsterbänk · 18 mm Furu / Obehandlad · 2 st" utan ett enda mått.
         Verkstaden hade kapat två likadana skivor i okänd storlek.
         Function Studios `_components` tar ett `properties`-objekt per komponent som appen
         skriver ut som radegenskaper på den expanderade raden (deras dokumentation,
         function-studio.app/docs/cart-expand). Samma spec skickas därför två gånger: som
         radegenskap (korgen, kundens vy, admin) och i komponenten (ordern, papperet).
         ⚠️ Bara SYNLIGA nycklar. `_`-prefix är Shopifys konvention för dolda egenskaper, och
            `_components` i sig självt får så klart aldrig med sig sin egen kopia. */
      function synligaProps(p) {
        var ut = {};
        Object.keys(p).forEach(function (k) {
          /* ⚠️ MÅSTE FÖLJA MED NER I KOMPONENTEN. Prisvakten läser den EXPANDERADE
             komponentraden – den enda `order.line_items` innehåller – och utan den här
             markören räknar den fram ett pris UTAN startavgiften och larmar falskt på
             varje order som bär den. `_`-prefixet gör den osynlig för kunden. */
          if (k === '_Startavgift' || k.indexOf('_tillagg:') === 0) { ut[k] = String(p[k]); return; }
          if (k.charAt(0) === '_') return;
          var v = p[k];
          if (v === null || v === undefined || String(v) === '') return;
          ut[k] = String(v);
        });
        return ut;
      }
      /* ⚠️ `_pris_val` följer med som DOLD egenskap på komponenten. Den syns varken i kassan
         eller på papperet (`_`-prefix), men den är mallarnas kvitto på att radens VARIANT är
         en prisbärare och inte kundens val – utan den föll "Träslag: 19 mm MDF" bort igen så
         fort kundens val råkade stämma med bärarvarianten. Se docs/orderprinter.md. */
      /* ⚠️⚠️ ENGÅNGSKOSTNADEN TAS EN GÅNG (2026-11-03). `_components`-priset multipliceras med radens antal:
         fönsterbänk med egen NCS × 3 kostade 2 700 kr i avgift i stället för 900. Avgiften fördelas därför på
         styckpriset, på EN rad (Liam: två rader blev rörigt). `_engang_ingar` låser hela antalet i korgen, och
         ordervakten räknar om styckpriset med radens antal (prisvakt.js). */
      var styckKr = s.resultat.pris;
      if (s.resultat.engang > 0) {
        props['_engang_ingar'] = 'Ja';
        /* Samma bänk två gånger med samma antal hade fått identiska egenskaper, och Shopify slår då ihop
           raderna: 2 + 2 st till 4 st, med styckpriset för 2 och alltså avgiften dubbelt, på EN rad som
           ordervakten räknar om med 4 (2026-11-03). Ett unikt värde håller dem isär, och varje rad bär
           sin egen avgift. */
        props['_engang_rad'] = Date.now().toString(36) + '-' + Math.floor(Math.random() * 1e6).toString(36);
        styckKr = (s.resultat.pris + (s.antal - 1) * s.resultat.utan) / s.antal;
      }
      var komponentProps = synligaProps(props);
      komponentProps['_pris_val'] = props['_pris_val'];
      props['_components'] = JSON.stringify([
        { id: String(vid), price: styckKr.toFixed(2), qty: 1, properties: komponentProps }
      ]);

      var items = [{ id: vid, quantity: s.antal, properties: props }];

      var drawer = document.querySelector('wubs-cart-drawer');
      if (drawer && typeof drawer.cartRequest === 'function') {
        skickar = true;
        drawer.rensaKopFel(atc);
        drawer.cartRequest('cart/add.js', { items: items }).then(function () {
          skickar = false;
          if (typeof drawer.open === 'function') drawer.open();
        }, function () {
          // Korgen sa nej eller nätet är borta (2026-11-03): besked vid knappen, ingen låda utan varan.
          skickar = false;
          drawer.visaKopFel(atc);
        });
      } else {
        skickar = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function () { window.location = '/cart'; });
      }
    }

    Object.keys(falt).forEach(function (k) {
      falt[k].addEventListener(falt[k].tagName === 'SELECT' ? 'change' : 'input', render);
    });

    /* ── GALLERIBILD PER VAL (Liam 2026-10-05: "kan jag vid val Avrundningar göra ett byte
       av bilden som visas?") ───────────────────────────────────────────────────────────
       Prisrutans fält byter aldrig variant – varianterna är Apippas slaskvarianter – så
       galleriet kan inte följa med på vanlig variantväg. I stället ropar rutan ut vilket
       val som gjordes, och galleriet får själv avgöra om det har en bild på saken.

       ⚠️ Lyssnaren sitter på SELECT:ens change, inte i render(). render() körs på varje
          tangenttryck i längd- och djupfälten, och hade kunden då scrollat fram en annan
          bild vore den ryckt tillbaka mitt i inmatningen.
       ⚠️ Prisrutan känner inte galleriet och ska inte göra det: den skickar etiketterna
          den redan visar, och kopplingen ligger i alt-texten (se wubs-product.js). */
    regler.inputs.forEach(function (inm) {
      if (inm.typ !== 'val') return;
      var el = falt[inm.nyckel];
      if (!el) return;
      el.addEventListener('change', function () {
        var traff = null;
        inm.alternativ.forEach(function (a) { if (a.slug === el.value) traff = a; });
        if (!traff) return;
        root.dispatchEvent(new CustomEvent('wubs:prisbild', {
          bubbles: true,
          detail: { nyckel: inm.nyckel, etikett: inm.etikett, slug: traff.slug, varde: traff.etikett }
        }));
      });
    });
    // NCS-fältet ligger utanför `falt` med flit: det är ingen prisinmatning och ska
    // aldrig hamna i _pris_val, men varje tangent ska uppdatera swatch och grind.
    if (ncsInput) ncsInput.addEventListener('input', render);
    if (qtyInput) {
      qtyInput.addEventListener('input', render);
      var dec = root.querySelector('[data-pk-qty-dec]');
      var inc = root.querySelector('[data-pk-qty-inc]');
      if (dec) dec.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); render();
      });
      if (inc) inc.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; render();
      });
    }
    document.addEventListener('wubs:variant:change', function (e) {
      if (e.detail && e.detail.variantId) root.setAttribute('data-variant', e.detail.variantId);
      render();
    });
    if (atc) atc.addEventListener('click', laggIVarukorg);

      render();
  }
})();
